import { CheckboxMain, TextToolTip } from 'components';
import { Svg } from 'assets';
import { LegTypesEnum, RateTypesForTable } from 'fragments';
import { convertToAmPm, renderName, renderPayerName } from 'utils';
import { TableHeaderVehicle } from '../dispatchBoard/fragments';

export const pendingTripsHead = ({ handleSelectAll, list, currentList, loadingList }) => {
  return [
    {
      renderView: (
        <CheckboxMain onChange={handleSelectAll} checked={!!list?.length && list?.length === currentList?.length} />
      ),
      width: 'fit-content',
    },

    {
      title: 'TP',
      custom: false,
      minWidth: 60,
      width: 60,
    },

    {
      title: 'MLS',
      name: 'distance',
      minWidth: 75,
      width: 75,
    },

    {
      title: 'LOS',
      name: 'los',
      minWidth: 68,
      width: 68,
    },

    {
      title: 'Status',
      name: 'statuses',
      custom: false,
      minWidth: 90,
      width: 90,
    },
    {
      title: 'VH',
      name: 'vehicle',
      rowName: 'unitNumber',
      ComponentView: TableHeaderVehicle,
      minWidth: 80,
      width: 80,
    },
    {
      title: 'Patient',
      name: 'patient',
      rowName: 'firstName',
      minWidth: 200,
      width: 200,
    },
    {
      title: 'PU Time',
      disabled: true,
      name: 'pickUp.scheduledTime',
      minWidth: 100,
      width: 100,
    },
    {
      title: 'Appt Time',
      disabled: true,
      name: 'dropOff.scheduledTime',
      minWidth: 100,
      width: 100,
    },
    {
      title: 'Pickup',
      disabled: true,
      name: 'pickUp.pickupTime',
      minWidth: 100,
      width: 100,
    },
    {
      title: 'Dropped',
      disabled: true,
      name: 'dropOff.arrivedTime',
      minWidth: 100,
      width: 100,
    },
    {
      title: 'Payor',
      name: 'payer',
      rowName: ['displayName', 'name'],
      minWidth: '104px',
      width: '104px',
    },
    {
      title: 'Origin',
      name: 'pickUp.address.street',
      minWidth: 197,
      width: 197,
    },
    {
      title: 'City',
      name: 'pickUp.address.city',
      minWidth: 81,
      width: 81,
    },
    {
      title: 'Zip',
      name: 'pickUp.address.zip',
      minWidth: 66,
      width: 66,
    },
    {
      title: 'Dest.',
      name: 'dropOff.address.street',
      minWidth: 164,
      width: 164,
    },
    {
      title: 'City',
      name: 'dropOff.address.city',
      minWidth: 81,
      width: 81,
    },
    {
      title: 'Zip',
      name: 'dropOff.address.zip',
      minWidth: 66,
      width: 66,
    },
  ];
};

export const pendingTripsBody = ({ handleCheck, currentList }) => {
  return [
    {
      button: (_, item) => {
        return <CheckboxMain onChange={() => handleCheck(item?.id)} checked={currentList?.includes(item?.id)} />;
      },
      width: 'fit-content',
    },

    {
      rowText: (item) => (
        <TextToolTip
          showTooltip
          arrow
          text={
            item?.type === LegTypesEnum.APPOINTMENT ? (
              <Svg.Hospital2Svg />
            ) : item?.type === LegTypesEnum.RETURN ? (
              <Svg.House2Svg />
            ) : item?.type === LegTypesEnum.ESCORT_PICKUP ? (
              <Svg.EscortPickup2Svg />
            ) : item?.type === LegTypesEnum.ESCORT_DROPOFF ? (
              <Svg.EscortDropOf2Svg />
            ) : (
              ''
            )
          }
          content={
            item?.type === LegTypesEnum.APPOINTMENT
              ? 'Appointment'
              : item?.type === LegTypesEnum.RETURN
                ? 'Patient return'
                : item?.type === LegTypesEnum.ESCORT_PICKUP || item?.type === LegTypesEnum.ESCORT_DROPOFF
                  ? 'Escort'
                  : ''
          }
          textStyles={{
            width: 'fit-content',
          }}
          wrapperStyles={{
            width: 'fit-content',
            margin: 'auto',
          }}
        />
      ),
      width: 60,
      minWidth: 60,
      styles: { padding: 0 },
    },

    {
      rowText: (item) => (
        <TextToolTip
          text={`${item?.distance || item?.distance === 0 ? Number(item?.distance.toFixed(2)) : ''}`}
          content={`${item?.distance || item?.distance === 0 ? Number(item?.distance.toFixed(2)) : ''}`}
        />
      ),
      width: 75,
      minWidth: 75,
    },

    {
      rowText: (item) => (
        <TextToolTip
          text={RateTypesForTable[item?.los ?? item?.patient?.los]}
          content={RateTypesForTable[item?.los ?? item?.patient?.los]}
          wrapperStyles={{
            width: 'fit-content',
            margin: 'auto',
          }}
        />
      ),
      minWidth: 68,
    },

    {
      rowText: () => (
        <div className="flex-all-center" style={{ gap: 2 }}>
          <TextToolTip
            classNameWrapper="dispatch-board-table-statuses-wrapper"
            text="Pending"
            content="Pending"
            wrapperStyles={{
              width: 'fit-content',
              background: '#FFFBEB',
            }}
            textStyles={{
              width: 'fit-content',
              color: '#D97706',
            }}
          />
        </div>
      ),
      width: 90,
      minWidth: 90,
    },

    {
      rowText: (item) => <TextToolTip text={item?.vehicle?.unitNumber} content={item?.vehicle?.unitNumber} />,
      minWidth: '80px',
    },

    {
      rowText: (item) => <TextToolTip text={renderName(item?.patient)} content={renderName(item?.patient)} />,
      minWidth: '200px',
    },

    {
      rowText: (item) => {
        return (
          <TextToolTip
            text={item?.pickUp?.scheduledTime ? convertToAmPm(item?.pickUp?.scheduledTime) : ''}
            content={item?.pickUp?.scheduledTime ? convertToAmPm(item?.pickUp?.scheduledTime) : ''}
          />
        );
      },
      minWidth: 100,
    },

    {
      rowText: (item) => {
        return (
          <TextToolTip
            text={item?.dropOff?.scheduledTime ? convertToAmPm(item?.dropOff?.scheduledTime) : ''}
            content={item?.dropOff?.scheduledTime ? convertToAmPm(item?.dropOff?.scheduledTime) : ''}
          />
        );
      },
      minWidth: 100,
    },

    {
      rowText: (item) => (
        <TextToolTip
          text={item?.pickUp?.pickupTime ? convertToAmPm(item?.pickUp?.pickupTime) : ''}
          content={item?.pickUp?.pickupTime ? convertToAmPm(item?.pickUp?.pickupTime) : ''}
        />
      ),
      minWidth: 100,
    },

    {
      rowText: (item) => (
        <TextToolTip
          text={item?.dropOff?.arrivedTime ? convertToAmPm(item?.dropOff?.arrivedTime) : ''}
          content={item?.dropOff?.arrivedTime ? convertToAmPm(item?.dropOff?.arrivedTime) : ''}
        />
      ),
      minWidth: 100,
    },

    {
      rowText: (item) => <TextToolTip text={renderPayerName(item?.payer)} content={renderPayerName(item?.payer)} />,
      minWidth: '104px',
    },
    {
      rowText: (item) => <TextToolTip text={item?.pickUp?.address?.street} content={item?.dropOff?.address?.street} />,
      minWidth: '197px',
    },

    {
      rowText: (item) => <TextToolTip text={item?.pickUp?.address?.city} content={item?.pickUp?.address?.city} />,
      minWidth: '81px',
    },
    {
      rowText: (item) => <TextToolTip text={item?.pickUp?.address?.zip} content={item?.pickUp?.address?.zip} />,
      minWidth: '66px',
    },
    {
      rowText: (item) => <TextToolTip text={item?.dropOff?.address?.street} content={item?.dropOff?.address?.street} />,
      minWidth: '164px',
    },

    {
      rowText: (item) => <TextToolTip text={item?.dropOff?.address?.city} content={item?.dropOff?.address?.city} />,
      minWidth: '81px',
    },
    {
      rowText: (item) => <TextToolTip text={item?.dropOff?.address?.zip} content={item?.dropOff?.address?.zip} />,
      minWidth: '66px',
    },
  ];
};

export const pendingTripsCsv = {
  path: '/legs/export/csv',
  defaultParams: {
    status: 'PENDING',
  },
};

export const emptyState = () => {
  return {
    notTitleText: 'No pending trips yet',
    EmptySvg: Svg.EmptyTrips,
  };
};